<template>
    <v-main class="ml-6 mt-3">
        <v-row dense>
            <v-col cols="12">
                <h3>Overview parks</h3>               
            </v-col>
        </v-row>
        <v-row dense class="mt-3">
            <v-col cols="12">
                <v-card fluid flat class="pr-6">
                    <v-card-title>Park information  <v-icon @click.stop="addParc()" class="ml-2">mdi-plus-circle-outline</v-icon></v-card-title>
                    <v-data-table :headers="getParcInfoHeaders()" 
                                  :items="parcs.info" 
                                  fixed-header :height="wInnerHeight - 200"
                                  :disable-pagination=true hide-default-footer item-key="connector_id" dense>
                        <template v-slot:body="{ items }" >
                            <tbody>
                                <tr v-for="(item, idx) in items" :key="idx" :class="{'test': item.isTest}">
                                    <td>{{ item.parkcode }}</td>
                                    <td><v-icon v-if="item.isTest" color="red">mdi-text-recognition</v-icon></td>
                                    <td>{{ item.parkname }}</td>
                                    <td align="right" class="numberfield">{{ fn(item.margin) }}
                                    </td>                                    
                                    <td>
                                        <v-avatar v-on:click="updateParc(item)" size="35" color="white" class="ma-1 ml-4 table-avatar">
                                            <v-icon size="30">mdi-playlist-edit</v-icon>
                                        </v-avatar>         
                                    </td>
                                    <td><span class="mr-3" @click="$router.open('/eign/onEign/' + item.eign_encrid)"><a>{{ item.eigncode }}</a></span></td>
                                    <td>{{ item.eignnaam | max_char(28) }}</td>
                                    <td>
                                      <v-icon v-if="item.AccosNotConnectedStatD!==0" size="25" color="warning">mdi-alert-outline</v-icon>                                    
                                      <v-icon v-if="item.AccosOwned===item.AccosOwnedStatD&&item.AccosOwned===item.AccosConnected" size="25" color="success">mdi-check-circle-outline</v-icon>
                                    </td>                                    
                                    <td>
                                      <v-icon v-if="item.type.toUpperCase() ==='COLLECTION'" size="22" color="warning">mdi-alpha-c-circle</v-icon>                                    
                                      <v-icon v-if="item.type.toUpperCase() ==='PARK'" size="22" color="success">mdi-alpha-p-circle</v-icon>
                                    </td>                                              
                                    <td align="center">{{ item.AccosOwned }}</td>
                                    <td align="center">{{ item.AccosOwnedStatD }}</td>
                                    <td align="center">{{ item.AccosConnected }}</td>
                                    <td align="center">{{ item.AccosNotConnected }}</td>
                                    <td align="center" :class="{'warning': item.AccosNotConnectedStatD!==0}">{{ item.AccosNotConnectedStatD }}</td>
                                    <td align="center">{{ item.NumPlannings }}</td>
                                    <td align="center">{{ item.NumPlanningsWithICall }}</td>
                                    <td align="center" :class="{'warning': item.NumPlannings !== item.NumPlanningsWithToCode}">{{ item.NumPlanningsWithToCode }}</td>
                                    <td>
                                        <v-avatar v-if="item.AccosOwned !== item.AccosConnected" @click="addAcco(item)" size="35" color="white" class="ma-1 table-avatar">
                                            <v-icon size="24">mdi-home-plus-outline</v-icon>
                                        </v-avatar>                               
                                    </td>                                                 
                                    <td>{{ item.calculationcodename }}</td>
                                    <td align="center">
                                        <v-avatar @click="$router.open('/task/pp/accommodations/' + item.parkcode)" size="35" color="white" class="ma-1 table-avatar">
                                            <v-icon size="24">mdi-home-search-outline</v-icon>
                                        </v-avatar>                               
                                    </td>                                    
                                    <td>{{ item.connector }}</td>
                                    <td>{{ item.connector_id }}</td>
                                    <td align="center">
                                        <v-avatar v-if="item.canBeDeleted" @click="deletePark(item.parkcode)" size="35" color="white" class="ma-1 table-avatar">
                                            <v-icon size="20">mdi-trash-can-outline</v-icon>
                                        </v-avatar>                               
                                    </td>                                              
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>                    
                </v-card>
            </v-col>        
        </v-row>        
        <navBar title="Ares - Purchase partners" :home="true" type="pp"/>
        <update_parc ref="update_parc" @reload="getParcInfo"/>
        <add_parc ref="add_parc" @reload="getParcInfo"/>
        <add_acco ref="add_acco" @reload="getParcInfo"/>
    </v-main>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import update_parc from '@/views/task/pp/update_parc.vue';
import add_parc from '@/views/task/pp/add_parc.vue';
import add_acco from '@/views/task/pp/add_acco.vue';
import mxscreensize from '@/components/js/screensize';
import mxmaxchar from '@/mixins/filtermaxchar';

export default {
    components: {
        navBar,
        update_parc,
        add_parc,
        add_acco
    },
    mixins: [mxscreensize, mxmaxchar],
    data() {
        return {
            parcs: {},
        }
    },
    created() {
        this.getParcInfo();
    },
    methods: {
        getParcInfoHeaders(){
            return [
                { text: "Code", value: "parkcode", sortable: false, width: "3%" },
                { text: "", value: "isTest", sortable: false, width: "1%" },
                { text: "Name", value: "parkname", sortable: true , width: "10%"},
                { text: "Margin", align: "end", sortable: false, value: "margin" },
                { text: "", sortable: false, width: "3%"},               
                { text: "Host", sortable: false, value: "eigncode" },
                { text: "Name", value: "eignnaam", sortable: true, width: "12%" },
                { text: "", align: "center", sortable: false,  width: "1%"},       
                { text: "", align: "center", sortable: false,  width: "1%"},       
                { text: "Acc", align: "center", value: "AccosOwned", sortable: false, width: "4%"},
                { text: "Acc D", align: "center", value: "AccosOwned", sortable: false, width: "4%"},
                { text: "Con", align: "center", value: "AccosConnected", sortable: false, width: "4%"},
                { text: "Unc", align: "center", value: "AccosNotConnected", sortable: false, width: "4%"},
                { text: "Unc D", align: "center", value: "AccosNotConnectedStatD", sortable: false, width: "4%"},
                { text: "Pln", align: "center", value: "NumPlannings", sortable: false, width: "4%"},
                { text: "+iCall", align: "center",value: "NumPlanningsWithICall", sortable: false, width: "4%"},
                { text: "+Toc", align: "center",value: "NumPlanningsWithICall", sortable: false, width: "4%"},
                { text: "", sortable: false, align: "center", width: "3%" },
                { text: "Method ", value: "", sortable: false, width: "7%" },
                { text: "List", align: "center", sortable: false},       
                { text: "Connector", sortable: false, value: "connector" },
                { text: "Suppl. Id", sortable: false, value: "connector_id", width: "5%" },               
                { text: "", align: "center", sortable: false,  width: "3%"},       
            ];
        },
        fn(value){
            return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value) + '%';
        },
        updateParc(park){
            this.$refs.update_parc.open(park);
        },        
        addParc(parkcode) {
            this.$refs.add_parc.open(parkcode);
        },
        addAcco(park) {
            this.$refs.add_acco.open(park);
        }, 
        deletePark(parkcode){
            console.log(parkcode)
            this.$axios
                .post("ares/json/ares/task/pp/deleteParkv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deletePark"
                    },
                    deletePark: parkcode
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.getParcInfo();
                    }
                })
        },                
        getParcInfo() {
            this.$axios
                .post("ares/json/ares/task/pp/getParkInfov2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getParcInfo"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.parcs = res.data.getParcInfo;
                    }
                })
        },
    }
}

</script>

<style scoped>
.numberfield{
    align-items: end;
    padding-right: 5px;
}
.table-avatar{
    cursor: pointer;
}
.check-avatar{
    cursor: default;
}
td{
    font-size: 9pt !important;
}
.warning{
    background-color: transparent !important; 
    font-weight: 800;
    border: 2px solid orange !important;
    font-size: 10pt !important;
}
.test{
    background-color: rgba(255, 0, 0, 0.1) !important; 
}
</style>